import criticalColor from '../assets/svg/criticalReportPrioIndicator.svg';
import highColor from '../assets/svg/highReportPrioIndicator.svg';
import lowColor from '../assets/svg/lowReportPrioIndicator.svg';
import mediumColor from '../assets/svg/mediumReportPrioIndicator.svg';

interface PriorityLevelProps {
  id: number;
  name: string;
  color: string;
}

const prioriryOptions: Array<PriorityLevelProps> = [
  {
    id: 0,
    name: 'Low',
    color: lowColor,
  },
  {
    id: 1,
    name: 'Medium',
    color: mediumColor,
  },
  {
    id: 2,
    name: 'High',
    color: highColor,
  },
  {
    id: 3,
    name: 'Critical',
    color: criticalColor,
  },
  {
    id: 4,
    name: 'Default',
    color: lowColor,
  },
];

export default prioriryOptions;
export { prioriryOptions as priorityOptions };
